import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Tab} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import DateFiltersSection from '../../../common/components/dateFilters/dateFiltersSection';
import SalesByDealers from './tabs/salesByDealers';
import StockByDealers from './tabs/stockByDealers';
import StockByModels from './tabs/stockByModels';
import './vehiclesKpi.scss';

const panes = [
  {'menuItem': 'Stock Nacional'},
  {'menuItem': 'Stock por modelo'},
  {'menuItem': 'Ventas'},
];

const PANES_INDICES = {
  'NATIONAL_STOCK': 0,
  'STOCK_BY_MODELS': 1,
  'SALES_BY_DEALERS': 2,
};

class VehiclesKpi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'dateFilters': {},
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
      'totalQuantity': 0,
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.VehiclesKpi,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchYearsWithHistoricalVehiclesSales();
  }

  onUpdateDateFiltersClick = (dateFilters) => {
    this.setState({
      dateFilters,
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
    });
  };

  changeTabIndex = (event, data) => {
    this.setState({
      'activeTabIndex': data.activeIndex,
      'dealerSelected': '',
      'modelSelected': '',
    });
  };

  onDateFiltersClearClick = (type) => {
    const newState = {...this.state.clearFilters};
    newState[type] = true;

    this.setState({'clearFilters': newState});
  }

  onUpdateTotalQuantityClick = (quantity) => {
    this.setState({'totalQuantity': quantity});
  }

  renderDateFiltersSection = () => {
    const {activeTabIndex, clearFilters} = this.state;
    const {loadingYears, years} = this.props;
    if (
      activeTabIndex === PANES_INDICES.NATIONAL_STOCK ||
      activeTabIndex === PANES_INDICES.STOCK_BY_MODELS
    ) {
      return null;
    }
    return (
      <DateFiltersSection
        loadingYears={loadingYears}
        years={years}
        clearFilters={clearFilters}
        onDateFiltersClick={this.onUpdateDateFiltersClick}
        showDays={true}
      />
    );
  };

  renderPanesContent = () => {
    const {activeTabIndex, dateFilters} = this.state;
    switch (activeTabIndex) {
      default:
      case PANES_INDICES.NATIONAL_STOCK:
        return (
          <StockByDealers
            onUpdateTotalQuantity={this.onUpdateTotalQuantityClick}
          />
        );
      case PANES_INDICES.STOCK_BY_MODELS:
        return (
          <StockByModels
            onUpdateTotalQuantity={this.onUpdateTotalQuantityClick}
          />
        );
      case PANES_INDICES.SALES_BY_DEALERS:
        return (
          <SalesByDealers
            dateFilters={dateFilters}
            onDateFiltersClear={this.onDateFiltersClearClick}
            onUpdateTotalQuantity={this.onUpdateTotalQuantityClick}
          />
        );
    }
  }

  render() {
    const {activeTabIndex, totalQuantity} = this.state;
    const title =
      activeTabIndex === PANES_INDICES.SALES_BY_DEALERS ? 'Ventas' : 'Stock';

    return (
      <div className='vehicles-kpi'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>
                {title} de Vehículos: {getNumericValue(totalQuantity, 0)}
              </h2>
            </div>
            <div className='filters-section'>
              <Grid>
                <Grid.Row textAlign='center'>
                  <Grid.Column width={16} className='filters-container'>
                    {this.renderDateFiltersSection()}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <Tab
            menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
            panes={panes}
            defaultActiveIndex={activeTabIndex}
            onTabChange={this.changeTabIndex}
          />
        </Card>

        <Card fluid raised>
          {this.renderPanesContent()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'years': state.vehiclesKpi.years,
    'loadingYears': state.vehiclesKpi.loadingYears,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  withRouter,
  fetchYearsWithHistoricalVehiclesSales,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  navigateTo,
  fetchYearsWithHistoricalVehiclesSales,
})(VehiclesKpi));
